import CustomModal from "../../../common-utilities/core/modal";
import SiTable from "../../../common-utilities/core/table";
import "./index.scss";
export const TableModal = ({
  title,
  closeModal,
  header,
  tableData,
  pageCount,
  tableClassName,
}) => {
  return (
    <CustomModal
      title={title}
      onClose={() => closeModal(null)}
      contentClassName={{
        headerBackgroundColor: "#008938",
        customClass: "tableModal",
      }}
    >
      <div className={`${tableClassName ? tableClassName : ""}`}>
        <SiTable
          header={header}
          data={tableData}
          pageCount={pageCount}
        ></SiTable>
      </div>
    </CustomModal>
  );
};
